import React from 'react';
import '../../scss/controls/_button.scss';

export enum ButtonTheme {
    Primary = 'primary',
    Secondary = 'secondary',
    Tertiary = 'tertiary',
    Decline = 'decline',
    LinkBlue = 'linktheme blue',
    LinkRed = 'linktheme red',
}

export const Button: React.FC<{
    id: string;
    dataTestid?: string;
    theme?: ButtonTheme;
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset';
    handleClick?: React.MouseEventHandler;
    hint?: string;
    width?: string;
    maxWidth?: string;
    visible?: boolean;
    children: any;
}> = ({
    id,
    dataTestid,
    theme = ButtonTheme.Primary,
    handleClick,
    hint,
    disabled = false,
    type = 'button',
    width = 'auto',
    maxWidth = 'auto',
    visible = true,
    children,
}) => {
    const setStyle = {
        cursor: `${!handleClick || disabled ? 'auto' : 'pointer'}`,
        width: width,
        maxWidth: maxWidth,
        visibility: visible ? 'visible' : 'hidden',
    };

    return (
        <button
            id={id}
            data-testid={dataTestid}
            className={`standardButton ${theme} ${disabled ? 'disabled' : 'active'}`}
            style={setStyle}
            onClick={handleClick}
            title={hint}
            type={type}
            disabled={disabled}
        >
            {children}
        </button>
    );
};
